import React from "react"
import FavouritesBadge from "../../../FavouritesBadge"
import urls from "../../../../config/urls"
import {FavouritesProps} from "../props"

const ClubFavourites = ({altText, hasFavourites, realm, variant, iconsVersionPath}: FavouritesProps) => {
    const hideBadge = !hasFavourites
    const {favourites} = urls
    const iconUrl = favourites.iconUrl(realm, variant, false, "large", iconsVersionPath)
    return <FavouritesBadge hideBadge={hideBadge} altText={altText} iconUrl={iconUrl} />
}

export default ClubFavourites
